// Sample cutouts for homepage poster rotation + feed fallbacks (served from `public/cutouts/`)
const publicBase = (typeof process !== 'undefined' && process.env.PUBLIC_URL) || '';

export const sampleCutouts = [1, 2, 3, 4, 5, 6].map(
  (n) => `${publicBase}/cutouts/${n}.jpg`
);

/** `selfGender` for hero sample strip: cutout 1 = M, 2 = F, 3 = M, 4 = NB, 5 = F, 6 = M (same order as `sampleCutouts`). */
const SAMPLE_CUTOUT_SELF_GENDER_BY_ORDER = ['male', 'female', 'male', 'nb', 'female', 'male'];

const SAMPLE_CUTOUT_SELF_GENDER_BY_NUM = { 1: 'male', 2: 'female', 3: 'male', 4: 'nb', 5: 'female', 6: 'male' };

/** Resolve editor/feed `selfGender` from a public sample cutout URL (`/cutouts/N.jpg`). */
export function getSelfGenderForSampleCutoutUrl(url) {
  if (!url || typeof url !== 'string') return 'male';
  const idx = sampleCutouts.indexOf(url);
  if (idx >= 0 && idx < SAMPLE_CUTOUT_SELF_GENDER_BY_ORDER.length) {
    return SAMPLE_CUTOUT_SELF_GENDER_BY_ORDER[idx];
  }
  const m = url.match(/\/cutouts\/(\d+)\.jpe?g\b/i);
  if (m) {
    const n = parseInt(m[1], 10);
    if (SAMPLE_CUTOUT_SELF_GENDER_BY_NUM[n]) return SAMPLE_CUTOUT_SELF_GENDER_BY_NUM[n];
  }
  return 'male';
}

// Fallback cutout URLs from Firebase Storage (used when nano-banana generation fails/times out)
const FALLBACK_MALE = [
  'https://firebasestorage.googleapis.com/v0/b/luvf-634c7.firebasestorage.app/o/cutouts%2Fmale%2F2.png?alt=media&token=a33ccf1c-c8a7-44e2-8b60-c3f01e24966e',
  'https://firebasestorage.googleapis.com/v0/b/luvf-634c7.firebasestorage.app/o/cutouts%2Fmale%2F13.png?alt=media&token=2e7215fd-6292-4299-933d-b4bbecf3a44e',
  'https://firebasestorage.googleapis.com/v0/b/luvf-634c7.firebasestorage.app/o/cutouts%2Fmale%2F8.png?alt=media&token=2be63860-453f-47a8-9a19-50beb0cc0f5a',
];

const FALLBACK_FEMALE = [
  'https://firebasestorage.googleapis.com/v0/b/luvf-634c7.firebasestorage.app/o/cutouts%2Ffemale%2F666.png?alt=media&token=47171d7b-e13a-4a28-9b3c-0ced2c74e9d5',
  'https://firebasestorage.googleapis.com/v0/b/luvf-634c7.firebasestorage.app/o/cutouts%2Ffemale%2F777.png?alt=media&token=40fcdf25-c42d-4f3e-9c39-597e1aad2621',
  'https://firebasestorage.googleapis.com/v0/b/luvf-634c7.firebasestorage.app/o/cutouts%2Ffemale%2F555.png?alt=media&token=00172be7-5323-4df5-90ef-ac8094351d34',
  'https://firebasestorage.googleapis.com/v0/b/luvf-634c7.firebasestorage.app/o/cutouts%2Ffemale%2F444.png?alt=media&token=7bf2f718-3d96-4153-bbc3-5ea3adf6e547',
];

const normalizeLookingFor = (val) => {
  const s = (val || '').toString().toLowerCase().trim();
  if (s === 'female' || s === 'woman' || s === 'women') return 'female';
  if (s === 'nb' || s === 'non-binary' || s === 'nonbinary' || s === 'enby') return 'nb';
  if (s === 'male' || s === 'man' || s === 'men') return 'male';
  return null;
};

function getFallbackCutoutsForGender(lookingFor) {
  const key = normalizeLookingFor(lookingFor);
  if (key === 'female') return FALLBACK_FEMALE;
  if (key === 'nb') return [...FALLBACK_MALE, ...FALLBACK_FEMALE];
  if (key === 'male') return FALLBACK_MALE;
  return [...FALLBACK_MALE, ...FALLBACK_FEMALE];
}

export function getRandomSampleCutout(lookingFor) {
  const list = getFallbackCutoutsForGender(lookingFor);
  return list[Math.floor(Math.random() * list.length)];
}
